module.exports = __webpack_public_path__ + "static/media/companyLawyer-Wed_20.8c336a5c.jpg";